import { Card, Grid, AreaChart, Title, Subtitle } from "@tremor/react";
import { Gauge, MousePointerClick } from "lucide-react";
import { SectionHeader } from "@/components/ui/SectionHeader";
import { costInWindow } from "@/data/derived";
import { useFilterVersion } from "@/data/filters";
import { useDrilldown } from "@/components/drilldown/Drilldown";
import { eurAxis, formatLunaKey } from "@/lib/format";

export function CostProductieSection() {
  useFilterVersion();
  const { openDrill } = useDrilldown();
  const data = costInWindow().map((r) => ({
    ...r,
    luna: formatLunaKey(r.luna_key),
  }));

  function drill(v: unknown) {
    const luna = (v as { luna_key?: string } | null)?.luna_key;
    if (luna) openDrill({ type: "luna", valoare: luna });
  }

  return (
    <section>
      <SectionHeader
        id="cost-productie"
        icon={Gauge}
        titlu="1. Cost producție /oră și /unitate"
        descriere="Evoluție lunară — costul REAL măsurat pe centrele productive (nu constanta declarată de 200 €/oră)."
      />
      <div className="mb-3 flex items-center gap-1.5 text-xs text-slate-400">
        <MousePointerClick className="h-3.5 w-3.5" />
        Click pe o lună din grafic → breakdown-ul lunii (cost, comenzi, mașini).
      </div>
      <Grid numItemsMd={2} className="gap-4">
        <Card className="ring-slate-200">
          <Title>Cost /oră (€)</Title>
          <Subtitle>Σ cost_total / Σ ore_lucrate, centre productive</Subtitle>
          <AreaChart
            className="mt-4 h-72 w-full"
            data={data}
            index="luna"
            categories={["cost_pe_ora_eur"]}
            colors={["blue"]}
            valueFormatter={eurAxis}
            showLegend={false}
            curveType="monotone"
            yAxisWidth={64}
            startEndOnly={false}
            noDataText="Fără date"
            onValueChange={drill}
          />
        </Card>
        <Card className="ring-slate-200">
          <Title>Cost /unitate produsă (€ / m² echiv.)</Title>
          <Subtitle>Σ cost_total / Σ unități produse</Subtitle>
          <AreaChart
            className="mt-4 h-72 w-full"
            data={data}
            index="luna"
            categories={["cost_pe_unitate_eur"]}
            colors={["indigo"]}
            valueFormatter={eurAxis}
            showLegend={false}
            curveType="monotone"
            yAxisWidth={64}
            noDataText="Fără date"
            onValueChange={drill}
          />
        </Card>
      </Grid>
    </section>
  );
}
